export default {"src":"/_next/static/media/laptop-2.772526f1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};